import React from 'react'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import styles from './SegmentBar.module.scss'

export interface ISegmentBarItem {
  key: string
  label: string
  value: number
  color: string
}

interface ISegmentBarProps {
  segments: ISegmentBarItem[]
  // доля в подсказке считается от total, а не от суммы сегментов
  total: number
  className?: string
}

export const formatPercent = (value: number, total: number) =>
  total ? `${Math.round((value / total) * 100)}%` : '0%'

export const SegmentDot: React.FC<{ color: string }> = ({ color }) => (
  <span className={styles.dot} style={{ background: color }} />
)

export const SegmentBar: React.FC<ISegmentBarProps> = ({ segments, total, className }) => (
  <div className={classNames(styles.bar, className)}>
    {segments
      .filter(({ value }) => value > 0)
      .map(({ key, label, value, color }) => (
        <Tooltip
          key={key}
          title={
            <>
              <SegmentDot color={color} />
              {label}: {value} ({formatPercent(value, total)})
            </>
          }
        >
          <span className={styles.segment} style={{ flexGrow: value, background: color }} />
        </Tooltip>
      ))}
  </div>
)
